<mat-chip-listbox *ngIf="status && label">
  <mat-chip-option
    [class]="['status-chip', statusClass]"
    [selectable]="false"
    [disableRipple]="true"
  >
    {{ label }}
  </mat-chip-option>
</mat-chip-listbox>
